var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1500_17530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.65 3.46006C11.92 2.75006 11.29 2.01006 10.53 2.12006C5.00999 2.92006 1.05999 8.19006 2.18999 14.0001C2.96999 18.0201 6.27999 21.2101 10.33 21.8701C14.07 22.4801 17.49 21.0001 19.65 18.4301C20.13 17.8601 19.84 16.9501 19.1 16.8101C13.08 15.6601 9.41999 9.27006 11.65 3.46006Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1500_17530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightDark);
export default __webpack_public_path__ + "static/media/NightDark.86ebddceab36ba1d512e690b341bbb7e.svg";
export { ForwardRef as ReactComponent };